import reducer, {
  actions,
  selectors,
  STATE_KEY,
} from 'src/redux/data/customers/modules/slice';
import saga from 'src/redux/data/customers/modules/saga';

import Component from './Component';

export { saga, actions, reducer, selectors, STATE_KEY };
export default Component;
